import PropPresetPopover from "../../prop_presets/PropPresetPopover";
import InteractionPointPreview, {
  EmptyPropPointStrategy,
  PropPointStrategy,
} from "../InteractionPointPreview";
import usePropPointPreview from "../PropPointPreview.hook";
import useSituationPropPoint from "./SituationPropPoint.hook";

import {
  addPropStateToSelectedTake,
  removePropStateFromSelectedTake,
} from "../../../app/slices/TrainingSlice";
import { useDispatch } from "react-redux";
import { RgbaColor } from "../../../app/slices/EnvironmentSlice";
import { Vec2D } from "../../../models/Vec2D";
export default function SituationPropPoint(props: {
  situationId: string;
  positionId: string;
  x: number;
  y: number;
  disabled: boolean;
  takeColor?: RgbaColor;
  positionDirection?: Vec2D;
  animateFrom?: Vec2D & { id: string };
}) {
  const dispatch = useDispatch();
  const {
    x,
    y,
    disabled,
    positionId,
    situationId,
    takeColor,
    positionDirection,
  } = { ...props };
  const { doesSituationNodeHaveChild, getSpawnedProp } =
    useSituationPropPoint();
  const { openPropLibrary } = usePropPointPreview();

  const hasChild = doesSituationNodeHaveChild(positionId);
  const myPropTakeState = getSpawnedProp(situationId + "/" + positionId);

  const onAddProp = (instanceId: string, propId: string) => {
    dispatch(
      addPropStateToSelectedTake({
        instanceId: instanceId,
        positionId: situationId + "/" + positionId,
      })
    );
  };

  const onDeletePropFromPosition = () => {
    if (!myPropTakeState) return;
    dispatch(removePropStateFromSelectedTake(myPropTakeState.id));
  };

  const popoverContent = (
    <PropPresetPopover
      canDelete={myPropTakeState !== undefined}
      onClick={onAddProp}
      onDelete={onDeletePropFromPosition}
      includedGrabbedProps={false}
      onAddNewPropClick={() => openPropLibrary(situationId + "/" + positionId)}
      currentPropTakeState={myPropTakeState}
    />
  );

  return (
    <>
      <InteractionPointPreview
        animateFrom={props.animateFrom}
        x={x}
        y={y}
        strategy={
          hasChild || myPropTakeState
            ? PropPointStrategy
            : EmptyPropPointStrategy
        }
        markerBorderColor={takeColor}
        markerIconColor={hasChild || myPropTakeState ? takeColor : undefined}
        directionDegrees={positionDirection?.x}
        directionColor={takeColor}
        disabled={disabled}
        popoverContent={!hasChild ? popoverContent : undefined}
      />
    </>
  );
}
